import { ProfilePage } from 'schema-dts';
import { IUserDetail } from 'shared/models';
import { TFunction } from 'i18next';

export const ProfileJsonLdUtil = {
  fromUserDetail: (props: { user: IUserDetail; t: TFunction }): ProfilePage => {
    const { user, t } = props;

    const description = t('user_helmet_description_1')
      .replace('%1$s', user.nickName || '')
      .replace('%2$s', user.description || '');

    return {
      '@type': 'ProfilePage',
      mainEntity: {
        '@type': 'Person',
        name: user.nickName,
        alternateName: user.linkName,
        identifier: {
          '@type': 'PropertyValue',
          propertyID: 'Username',
          value: user.linkName,
        },
        interactionStatistic: [
          {
            '@type': 'InteractionCounter',
            interactionType: {
              '@type': 'LikeAction',
            },
            userInteractionCount: user.dugCount + user.favoredCount,
          },
          {
            '@type': 'InteractionCounter',
            interactionType: {
              '@type': 'FollowAction',
            },
            userInteractionCount: user.followerCount,
          },
          {
            '@type': 'InteractionCounter',
            interactionType: {
              '@type': 'BookmarkAction',
            },
            userInteractionCount: user.dugCount + user.favoredCount,
          },
          {
            '@type': 'InteractionCounter',
            interactionType: {
              '@type': 'WriteAction',
            },
            userInteractionCount: user.postCount,
          },
        ],
        description,
        image: user.avatar,
      },
    };
  },
};
